import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";

import { getJSON } from "@js/helpers/communication.js";

export const CE_MODAL_UPLOAD_FROM_URL_OPEN = "CE_MODAL_UPLOAD_FROM_URL_OPEN";
export const ceModalUploadFromUrlOpen = (clientContentID) => ({
  type: CE_MODAL_UPLOAD_FROM_URL_OPEN,
  client_content_id: clientContentID,
});

export const CE_MODAL_UPLOAD_FROM_URL_REOPEN =
  "CE_MODAL_UPLOAD_FROM_URL_REOPEN";
export const ceModalUploadFromUrlReopen = () => ({
  type: CE_MODAL_UPLOAD_FROM_URL_REOPEN,
});

export const CE_MODAL_UPLOAD_FROM_URL_SAVE_STARTED =
  "CE_MODAL_UPLOAD_FROM_URL_SAVE_STARTED";
export const CE_MODAL_UPLOAD_FROM_URL_SAVE_FAILURE =
  "CE_MODAL_UPLOAD_FROM_URL_SAVE_FAILURE";
export const CE_MODAL_UPLOAD_FROM_URL_SAVE_SUCCESS =
  "CE_MODAL_UPLOAD_FROM_URL_SAVE_SUCCESS";
export const CE_MODAL_UPLOAD_FROM_URL_SAVE_ABORTED =
  "CE_MODAL_UPLOAD_FROM_URL_SAVE_ABORTED";
export const ceModalUploadFromUrlSave = (format) => (dispatch, getState) => {
  // Get the initial state and indicate that we're starting.

  let initialState = getState();
  let initialModal = initialState.modal.uuid;
  let { url } = initialState.modal.state;

  dispatch({ type: CE_MODAL_UPLOAD_FROM_URL_SAVE_STARTED, format: format });

  // Ensure we don't have any validation errors.

  let validationState = getState();

  if (validationState.modal.state.validation_error) {
    dispatch({
      type: CE_MODAL_UPLOAD_FROM_URL_SAVE_ABORTED,
      reason: "validation error",
    });
    return;
  } else if (validationState.modal.state.step !== "downloading") {
    dispatch({
      type: CE_MODAL_UPLOAD_FROM_URL_SAVE_ABORTED,
      reason: "did not advance to downloading",
    });
    return;
  }

  // Execute the HTTP request.

  let gaGetUrl = Routes.load_url_content_tools_path({ url: url });

  getJSON(gaGetUrl, (data, err) => {
    let finalState = getState();
    let finalModal = finalState.modal && finalState.modal.uuid;

    if (!initialModal || !finalModal || initialModal !== finalModal) {
      // The modal was closed while we were working on the network request.
      dispatch({
        type: CE_MODAL_UPLOAD_FROM_URL_SAVE_ABORTED,
        reason: "modal closed",
      });
    } else if ((data && data.error) || err) {
      // Download error.
      dispatch({
        type: CE_MODAL_UPLOAD_FROM_URL_SAVE_FAILURE,
        error: (data && data.error) || err,
      });
    } else {
      // Success!
      dispatch({
        type: CE_MODAL_UPLOAD_FROM_URL_SAVE_SUCCESS,
        data: data.content,
      });
    }
  });
};

export const ceModalUploadFromUrlCancel = () => ({
  type: CE_MODAL_CLOSE,
});
